const mutations = {
  addDataApi: (state, payload) => {
    state.dataAPI = payload;
  },
  removeDataApi: (state) => {
    state.dataAPI = "";
  },
  addLogin: (state, payload) => {
    state.login = payload;
  },
};

export default mutations;
